var map = {
	"./16.png": "c2ae",
	"./24.png": "60e8",
	"./8.png": "eadf",
	"./B-1.png": "f52a",
	"./B.png": "7952",
	"./BP1.png": "4749",
	"./BP2-1.png": "eda3",
	"./BP2.png": "d82d",
	"./BS-1.png": "5426",
	"./BS.png": "4488",
	"./C1-1.png": "0899",
	"./C1.png": "d0dc",
	"./C2.png": "b592",
	"./C3.png": "deea",
	"./CP1.png": "ea11",
	"./CP2.png": "ced7",
	"./CP3.png": "b503",
	"./CP4.png": "430b",
	"./D1.png": "510e",
	"./D2.png": "f894",
	"./DK.png": "1283",
	"./DP1.png": "25e5",
	"./DP2.png": "7620",
	"./DS.png": "fc70",
	"./E.png": "0730"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";